import { useContext } from "react";
import IOAbstract, { EditContext, type IOProps } from "./io-abstract";

export default function IOHidden(props: IOProps<string | number>) {
  const editContext = useContext(EditContext);

  return (
    <IOAbstract<string | number>
      editContext={editContext}
      type="hidden"
      renderOutput={<div>{props.value}</div>}
      renderInput={(uuid) => (
        <div>
          {props.value ?? ""}
          <input
            id={uuid}
            type="hidden"
            name={props.name}
            value={props.value ?? ""}
            {...props.htmlProps}
          />
        </div>
      )}
      {...props}
    />
  );
}
